import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const Camera = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 20"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 5.555h-1.37L13.02 3.89H7.98L6.87 5.555H5.5c-.919 0-1.667.748-1.667 1.667v7.222c0 .92.748 1.667 1.667 1.667h10c.919 0 1.667-.748 1.667-1.667V7.222c0-.919-.748-1.667-1.667-1.667Zm-5 8.056a2.778 2.778 0 1 1 0-5.556 2.778 2.778 0 0 1 0 5.556Zm3.889-5.833a.556.556 0 1 0 1.111 0 .556.556 0 0 0-1.111 0Z"
        fill={props.color || theme.palette.grey600}
      />
    </svg>
  );
};

export { Camera };
